import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';

import { OrganizationService } from '@core/services/organization.service';

@Component({
  selector: 'app-organization-share-email',
  templateUrl: './share-email.component.html',
  styleUrls: [
    './share-email.component.scss',
    '../../property-share-modal/share-emails/share-emails.component.scss',
  ],
})
export class OrganizationShareEmailComponent {
  @Output() handleClose = new EventEmitter<void>();

  protected emailValue = '';
  protected emailInvalid = false;
  protected emailTouched = false;
  protected emails: string[] = [];

  protected sending = false;
  protected sendResp:
    | { type: 'success' | 'error'; message: string }
    | undefined;

  constructor(
    private organizationService: OrganizationService,
    private cdr: ChangeDetectorRef
  ) {}

  addEmail() {
    this.sendResp = undefined;
    if (this.isValidEmail(this.emailValue)) {
      this.emails.push(this.emailValue);
      this.emailValue = '';
      this.emailInvalid = false;
      this.emailTouched = false;
    } else {
      this.emailInvalid = true;
      this.emailTouched = true;
    }
  }

  removeEmail(index: number) {
    this.emails.splice(index, 1);
  }

  isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  responseError() {
    this.sendResp = {
      type: 'error',
      message: 'Failed to share property. Please try again later.',
    };

    this.sending = false;
    this.cdr.detectChanges();
    setTimeout(() => {
      this.sendResp = undefined;
      this.cdr.detectChanges();
    }, 7000);
  }

  onEmailBlur() {
    this.emailTouched = true;
  }

  handleSend() {
    this.sending = true;
    this.sendResp = undefined;

    this.organizationService
      .shareOrganizationWithInvestors({
        input: {
          emails: this.emails,
        },
      })
      .subscribe({
        next: (result) => {
          if (result.shareOrganizationWithInvestors) {
            this.sendResp = {
              type: 'success',
              message: 'Successfully shared organization with investors.',
            };
            this.emails = [];
            this.emailValue = '';
            this.emailInvalid = false;
            this.emailTouched = false;
          } else {
            this.responseError();
          }

          this.sending = false;
          this.cdr.detectChanges();
          setTimeout(() => {
            this.sendResp = undefined;
            this.cdr.detectChanges();
          }, 7000);
        },
        error: (err) => this.responseError(),
      });
  }
}
